import { tagService } from '../../services/tagService';

const getDefaultState = () => {
  return {
    tags: []
  }
}

const state = getDefaultState();


const getters = {
  tags: state => state.tags
}

const actions = {
  resetTagsState ({ commit }) {
    commit('RESET_TAGS_STATE');
  },
  async fetchTags({ commit }) {
    commit('SET_LOADING', true);
    try {
      const response = await tagService.getAll();
      commit('SET_TAGS', response.data.data);
      commit('SET_LOADING', false);
    } catch (error) {
      const errorMessage = error.response.data.error;
      commit('SET_LOADING', false);
      commit('SHOW_SNACKBAR', { text: `Ocorreu um erro ao buscar as tags: ${errorMessage}`, status: 'error' });
      commit('SET_TAGS', []);
    }
  },
  async fetchTagById({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      const response = await tagService.getById(id);
      commit('SET_LOADING', false);
      return response.data.data;
    } catch (error) {
      const errorMessage = error.response.data.error;
      commit('SET_LOADING', false);
      commit('SHOW_SNACKBAR', { text: `Ocorreu um erro ao buscar a tag: ${errorMessage}`, status: 'error' });
      return error;
    }
  },
  async createTag({ commit }, tag) {
    commit('SET_LOADING', true);
    try {
      const response = await tagService.create(tag);
      commit('SET_TAG', response.data.data);
      commit('SET_LOADING', false);
      commit('SHOW_SNACKBAR', { text: 'Tag criada com sucesso!', status: 'success' });
    } catch (error) {
      const errorMessage = error.response.data.error;
      commit('SET_LOADING', false);
      commit('SHOW_SNACKBAR', { text: `Ocorreu um erro ao criar a tag: ${errorMessage}`, status: 'error' });
    }
  },
  async deleteTag({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      await tagService.destroy(id);
      commit('REMOVE_TAG', id);
      commit('SET_LOADING', false);
      commit('SHOW_SNACKBAR', { text: 'Tag excluída com sucesso!', status: 'success' });
    } catch (error) {
      const errorMessage = error.response.data.error;
      commit('SET_LOADING', false);
      commit('SHOW_SNACKBAR', { text: `Ocorreu um erro ao excluir a tag: ${errorMessage}`, status: 'error' });
    }
  },
  async updateTag({ commit }, tag) {
    commit('SET_LOADING', true);
    try {
      const response = await tagService.update(tag);
      commit('UPDATE_TAG', response.data.data);
      commit('SET_LOADING', false);
      commit('SHOW_SNACKBAR', { text: 'Tag atualizada com sucesso!', status: 'success' });
    } catch (error) {
      const errorMessage = error.response.data.error;
      commit('SET_LOADING', false);
      commit('SHOW_SNACKBAR', { text: `Ocorreu um erro ao atualizar a tag: ${errorMessage}`, status: 'error' });
    }
  }
}

const mutations = {
  RESET_TAGS_STATE: (state) => Object.assign(state, getDefaultState()),
  SET_TAGS: (state, tags) => state.tags = tags,
  SET_TAG: (state, tag) => state.tags.push(tag),
  REMOVE_TAG: (state, id) => state.tags = state.tags.filter(tag => tag._id !== id),
  UPDATE_TAG: (state, updTag) => {
    const index = state.tags.findIndex(tag => tag._id === updTag._id);
    if (index !== -1) {
      state.tags.splice(index, 1, updTag);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}